export default __webpack_public_path__ + "static/media/sprite.87adba6b.svg";